export const FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
export const SHEET_NAME = 'data'
export const BOOK_TYPE = 'xlsx'
export const TYPE = 'array'
export const FILE_NAME = 'articles.xlsx'
export const COLUMN_WIDTHS = 'articles.xlsx'
export const DATE_FORMAT = 'DD/MM/YYYY'
export const ARRAY_COLUMNS = ['organisations', 'sub_categories']
export const DATE_COLUMNS = ['created']
export const NAMED_COLUMNS = ['category']
export const LITERAL_COLUMNS = ['title', 'short_description', 'update_frequency', 'published', 'is_draft', 'pinned', 'created']
